// Register
export const INDIVIDUAL_TYPE = "individual";
export const CORPORATE_TYPE = "corporate";

// Status
export const STATUS = {
  Pending: "pending",
  Delivery: "delivery",
  Complete: "complete",
};
